/**
 * Initialize Matomo analytics when a site ID is available.
 * Safe to call multiple times; loads the tracker script once.
 */
export function initMatomo(analyticsSiteId) {
    if (!analyticsSiteId) {
        return false;
    }

    const matomoUrl = process.env.MATOMO_API_URL;
    if (!matomoUrl) {
        console.warn('Matomo: MATOMO_API_URL is not configured');
        return false;
    }

    const siteId = String(analyticsSiteId);
    window._paq = window._paq || [];

    if (window.__matomoSiteId === siteId && window.__matomoInitialized) {
        return true;
    }

    const trackerBase = matomoUrl.endsWith('/') ? matomoUrl : `${matomoUrl}/`;

    window._paq.push(['enableLinkTracking']);
    window._paq.push(['setTrackerUrl', `${trackerBase}matomo.php`]);
    window._paq.push(['setSiteId', siteId]);

    if (!window.__matomoInitialized) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = `${trackerBase}matomo.js`;
        const firstScript = document.getElementsByTagName('script')[0];
        if (firstScript?.parentNode) {
            firstScript.parentNode.insertBefore(script, firstScript);
        } else {
            document.head.appendChild(script);
        }
        window.__matomoInitialized = true;
    }

    window.__matomoSiteId = siteId;
    return true;
}

export function initMatomoFromSettings(settings) {
    return initMatomo(settings?.analytics_site_id);
}
